// extracted by mini-css-extract-plugin
export default {"form":"SignUpForm_form__hQW7B","submit":"SignUpForm_submit__JI3I6","input":"SignUpForm_input__IdxQK"};